export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  };

 export const filterEmail = (value: string): string => {
    return value.replace(/\s/g, "");
  };